import "../PopupDeleteAd/popupDelete.css";
import deleteIcon from "../asssets/delete-img.svg";
import {APICardRequest} from "../../../../API/api";
import {deleteLocalCard, getUserAds} from "../../../../redux/reducers/ads/sliceAds";

const PopupDelete = (props) => {
    const {
        modal, setModal, dispatch, setArchiveData, changeContinuePopup, adsData,
        pageNumber, isTotalPages, userId, setPageNumber, totalCount
    } = props;

    const getNewArchiveAds = () => {
        APICardRequest.getActiveAds(userId, pageNumber, 10, true)
            .then(res => {
                // console.log(res)
                setArchiveData({
                    data: res.data,
                    total_pages: JSON.parse(res.headers['x-pagination']).total_pages,
                    totalCount: JSON.parse(res.headers['x-pagination']).total,
                    loading: false,
                })
            })
    }

    const handleDeleteCard = (e) => {
        e.stopPropagation();
        APICardRequest.deleteCard(modal.data.id)
            .then((r) => {
                // console.log(r)
                if (r.status === 204) {
                    const adName = modal.data.title;
                    if (setArchiveData) {
                        setArchiveData(prevState => ({
                            ...prevState,
                            data: prevState.data.filter(x => x.id !== modal.data.id)
                        }))

                        if ((totalCount - 1) % 10 === 0) {
                            if (pageNumber > 1 && pageNumber === isTotalPages) setPageNumber(pageNumber - 1)
                            setArchiveData(prevState => ({
                                ...prevState,
                                loading: true,
                            }))
                            return getNewArchiveAds()
                        } else if (adsData.length <= 1 && isTotalPages > 1) {
                            setArchiveData(prevState => ({
                                ...prevState,
                                loading: true,
                            }))
                            if (pageNumber > 1 && pageNumber === isTotalPages) setPageNumber(pageNumber - 1)
                            getNewArchiveAds()
                            window.scrollTo(0, 0);
                        }
                    } else {
                        dispatch(deleteLocalCard(modal.data.id))

                        if ((totalCount - 1) % 10 === 0) {
                            if (pageNumber > 1 && pageNumber === isTotalPages) setPageNumber(pageNumber - 1)
                            return dispatch(getUserAds({id: userId, page: pageNumber}))
                        } else if (adsData.length <= 1 && isTotalPages > 1) {
                            if (pageNumber > 1 && pageNumber === isTotalPages) setPageNumber(pageNumber - 1)
                            dispatch(getUserAds({id: userId, page: pageNumber}))
                            window.scrollTo(0, 0);
                        }
                    }
                    closeModal()
                    changeContinuePopup(`${adName} has been successfully removed`)
                    setTimeout(() => {
                        changeContinuePopup(`${adName} has been successfully removed`)
                    }, 3000)
                }
            })
            .catch((e) => {
                console.log(e)
                alert(e);
            });
    };

    const closeModal = () => {
        setModal({
            show: false,
            data: null,
        })
    }

    return (
        <div
            style={{
                background: modal.show ? "rgba(0, 0, 0, 0.5)" : "transparent",
            }}
            className={modal.show ? "modalDelete active" : "modalDelete"}
            onClick={closeModal}>
            <div
                className={"modal-content-delete"}
                onClick={(e) => e.stopPropagation()}>
                <div className={"close-and-feedback"}>
                    <div className={"leave-feedback"}>
                        <img src={deleteIcon} alt={"delete"}/>
                        <span>Delete Ad</span>
                    </div>
                    <div className={"close-button"}>
                        <svg className={"close_icon"}
                             onClick={closeModal}
                             height="24" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.6416 12.0002L18.5804 7.07632C19.0069 6.61883 18.9948 5.90538 18.5522 5.46381C18.1097 5.0213 17.3972 5.00819 16.9397 5.43475L12.0001 10.3586L7.07621 5.42731C6.62059 4.96982 5.88089 4.96792 5.4234 5.42356C4.96591 5.87824 4.96402 6.61888 5.41965 7.07636L10.3584 12.0002L5.41965 16.924C4.9931 17.3815 5.00527 18.095 5.44778 18.5366C5.89029 18.9791 6.60278 18.9922 7.06029 18.5656L11.9841 13.6418L16.908 18.5656H16.9089C17.3617 19.0269 18.1033 19.0344 18.5655 18.5806C19.0267 18.1278 19.0342 17.3862 18.5805 16.9241L13.6416 12.0002Z"
                                fill="#003E47"
                                fillOpacity="0.4"
                            />
                        </svg>
                    </div>
                </div>
                <div className={"sure-delete"}>
                    <span>Are you sure you want to delete the ad?</span>
                    <span>It will not be possible to undo this action</span>
                </div>

                <div className={"cancel-block"}>
                    <button
                        onClick={closeModal}
                        type="cancel"
                        className={"cancel"}>
                        <span>Cancel</span>
                    </button>
                </div>
                <div className={"delete-block"}>
                    <button onClick={handleDeleteCard} type="delete" className={"delete"}>
                        <span>Delete</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopupDelete;
